export default "__VITE_ASSET__5HyjvGXG__"